/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

export const USER_TYPE_GUEST = 'G';
export const REGISTRATION_APPROVAL_STATUS_APPROVED = 'Approved';
export const REGISTRATION_APPROVAL_STATUS_PENDING = 'PendingApproval';
export const GENERIC_USER_ID = '-1002';
